import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';

export const TrainingCTA = () => {
  const { t, language } = useLanguage();

  return (
    <section className="py-20 section-gradient-dark relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-bold text-white mb-6">
          {language === 'fr' 
            ? 'Besoin d\'une formation sur-mesure ?'
            : 'Need Custom Training?'}
        </h2>
        <p className="text-xl text-white/70 mb-8">
          {language === 'fr'
            ? 'Contactez-nous pour discuter d\'un programme adapté aux besoins spécifiques de votre cabinet.'
            : 'Contact us to discuss a program tailored to your firm\'s specific needs.'}
        </p>
        <Button asChild size="lg" className="text-lg px-8 bg-white text-foreground hover:bg-white/90 glow-primary">
          <Link to="/contact" className="flex items-center">
            {t('contact')}
            <ArrowRight className="ml-2 w-5 h-5" />
          </Link>
        </Button>
      </div>
    </section>
  );
};
